// these functions won't run at once, but will be available from anywhere via this.functionName
export const staticFunctions = {
    addDevicesClasses() {
        $("body").addClass(((typeof document.body.ontouchstart == "undefined") ? "no-touch" : "touch"));
        if ((/iP/i.test(navigator.userAgent))) {
            $("body").addClass("ios");
        }
    },

    formItem() {
        $(".form-item").each(function () {
            $(this).on("click.formItem", function () {
                $(this).addClass("focus").off("click.formItem").find("input.form-control, textarea.form-control").focus();
            });
        });

        $(".form-control").each(function () {
            let
                _this = $(this),
                formIitem = _this.closest(".form-item");

            if (_this.val()) {
                formIitem.addClass("focus");
            } else {
                formIitem.removeClass("focus");
            }

        }).on("focus", function () {
            $(this).closest(".form-item").addClass("focus active-focus");

        }).on("blur", function () {
            let
                _this = $(this),
                formItem = _this.closest(".form-item").removeClass("active-focus");

            if (!_this.val()) {
                formItem.removeClass("focus");
            }
        });
    }
};


export function headerFunction() {
    let
        doc = $(document),
        html = $("html");

    html.on("click", ".open-nav", function (ev) {
        ev.preventDefault();

        doc.off("click.eCloseNav").data("clickNav", false);

        if (html.hasClass("show-nav")) {
            html.removeClass("show-nav");
        } else {
            html.addClass("show-nav");

            doc.on("click.eCloseNav", function (e) {

                if (doc.data("clickNav") && ($(e.target).closest($(".nav")).length === 0)) {
                    doc.off("click.eOpenDropCard").data("clickNav", false);
                    html.removeClass("show-nav");
                }

                doc.data("clickNav", true);
            });
        }
    });

    if (html.find(".main-header").length) {
        html.addClass("has-main-header");
    }
}

export function contentScrollDown() {
    $(".page-heading").on("click", ".btn-down", function (e) {
        let curSection = $(e.delegateTarget);

        $("body, html").animate({
            scrollTop: parseInt(curSection.offset().top + curSection.outerHeight())
        }, 500);
    });
}

export function footerNav() {
    $(".footer-nav").each(function () {
        let parent = $(this).closest(".footer-block").addClass("has-list");
        parent.find("h5, .h5").append("<i class=\"corner\"></i>");
    });

    $(".footer-block").on("click", ".corner", function (e) {
        let
            curBlock = $(e.delegateTarget).toggleClass("open"),
            list = curBlock.find(".footer-nav");

        if (curBlock.hasClass("open")) {
            list.slideDown(400);
        } else {

            list.slideUp(400);
        }
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/module.js